import { buildQuery } from "src/utils/helper";

export const CMS_ENDPOINT = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms`;
export const CMS_ENDPOINT_V1 = `${CMS_ENDPOINT}/v1`;
export const CMS_ENDPOINT_V2 = `${CMS_ENDPOINT}/v2`;
export const S3_BUCKET_URL = `${process.env.REACT_APP_S3_BUCKET_URL}`;
export const WEB_APP_ENDPOINT = `${process.env.REACT_APP_WEB_APP_ENDPOINT}`;
export const CMS_NEST_ENDPOINT = `${process.env.REACT_APP_CSMS_NEST_ENDPOINT}/api/v3/cms`;
export const NEST_BASE_ENDPOINT = `${process.env.REACT_APP_CSMS_NEST_ENDPOINT}`;

export const loginUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/login`;
export const resetUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/resetpwdrequest`;
export const verificationAndResetUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/resetpwd`;
export const changePasswordUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/changepwd`;
export const getTnCUrl = (username) =>
  `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/check_TnC/${username}`;
export const updateTnCUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/update_TnC`;
const setupUrl = `${CMS_ENDPOINT_V1}/setup`;
export const userUrl = `${CMS_ENDPOINT_V1}/profile`;
export const usersUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/cmsUser`;
// export const rolesUrl = `${CMS_ENDPOINT_V1}/roles`;
// export const roleUrl = `${CMS_ENDPOINT_V1}/role`;
// export const getRoleUrlId = (id) => `${roleUrl}/${id}`;
export const rolesUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/role`; // List roles, POST new role
export const roleUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/role`;  // POST new role (same as above)
export const getRoleUrlId = (teamId, roleId) => `${CMS_ENDPOINT_V1}/team/${teamId}/role/${roleId}`; // GET, PUT, DELETE specific role
export const categoryUrl = `${setupUrl}/category`;
export const userTypeUrl = `${setupUrl}/usertype`;
export const chargersUrl = `/chargers`;
export const bulkCalPayoutsUrl = `/payouts/bulk_calculated`;
export const updateBulkPayoutsUrl = `/payouts/bulk`;
export const chargerUrl = `/charger`;
export const chargerIdUrl = (chargerId) => `${chargerUrl}/${chargerId}`;
export const tagsUrl = `/tags`;
export const tagsForRemoteOpUrl = `/tags/remoteop`;
export const availableTagsUrl = `/availabletags`;
export const tagUrl = `/tag`;
export const tagIdUrl = (tagId) => `${tagUrl}/${tagId}`;
export const tagChargerUrl = (tagId, chargerId = null) =>
  `${tagIdUrl(tagId)}/chargers${chargerId ? "/" + chargerId : ""}`;
export const tagUserUrl = (teamId, tagId) =>
  `${getTeamUrl(teamId, tagIdUrl(tagId))}/users`;
export const tagTopupHistoryUrl = (teamId, tagId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/tag/${tagId}/topups`;
export const rfidTagTransactionsUrl = (teamId, rfid, params = {}) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/tag/rfid/${rfid}/transactions${buildQuery(
    params
  )}`;
export const rfidTagTransactionsKpiUrl = (teamId, rfid, params = {}) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/tag/rfid/${rfid}/transactions/kpis${buildQuery(
    params
  )}`;
export const priceGroupsUrl = `/pricegroups`;
export const priceGroupUrl = `/pricegroup`;
export const priceGroupIdUrl = (priceGroupId) =>
  `${priceGroupUrl}/${priceGroupId}`;
export const transaction = `${CMS_ENDPOINT_V1}/company`;
export const transactionsUrl = `/transactions`;
export const transactionUrl = "/transaction";
export const refundUrl = (teamId) => `${CMS_ENDPOINT_V1}/refund/team/${teamId}`;
export const refundUrlPaginated = (teamId, page = 0, pageSize = 10, search = "") => {
  // Convert from 0-based to 1-based page for API
  const apiPage = page.toString();
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  return `${CMS_ENDPOINT_V1}/refund/team/${teamId}?page=${apiPage}&pageSize=${pageSize}${searchParam}`;
};
export const chargerTransactions = (id) => `/charger/${id}/transactions`;
export const chargerActiveTransactions = (id) =>
  `/charger/${id}/transactions/active`;
export const tagTransactions = (id) => `/tag/${id}/transactions`;
export const rfidUsageReportUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/tags/rfid-usage-report`;
export const rfidUsageReportEmailUrl = (teamId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/tags/rfid-usage-report/email`;
export const teamExcelDownloadUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/download-excel`;
export const transactionIdUrl = (transactionId) =>
  `${transactionUrl}/${transactionId}`;
export const meterValueUrl = (url, connectorId) =>
  `${url}/meter_value/${connectorId}`;
export const bulkTeamUploadUrl = `${CMS_ENDPOINT_V1}/team/bulk`;
export const teamsUrl = (parentTeamId) =>
  `${CMS_ENDPOINT_V1}/teams/${parentTeamId}`;
export const teamUrl = `${CMS_ENDPOINT_V1}/team`;
export const teamUrlId = (id) => `${teamUrl}/${id}`;
export const teamChargerLicenseUrl = (teamId) => `${teamUrl}/${teamId}/chargerLicense`;
export const teamChargerLicenseStatusUrl = (teamId) => `${teamUrl}/${teamId}/chargerLicense/status`;
export const teamChargerLicenseReportUrl = (teamId) => `${teamUrl}/${teamId}/chargerLicense/report`;
export const teamChargersWithoutLicenseUrl = (teamId) => `${teamUrl}/${teamId}/chargerWithoutLicense`;
export const teamChargerLicenseConfigUrl = (teamId) => `${teamUrl}/${teamId}/charger_license_config`;
export const teamPayoutScheduleUrl = (teamId) => `${teamUrl}/${teamId}/payout_schedule`;
export const teamAvailableChargerLicensesUrl = (teamId, chargerType) =>
  `${teamUrl}/${teamId}/available_charger_licenses${chargerType ? `?charger_type=${chargerType}` : ''}`;
export const chargerLicenseUrl = (teamId) => `${teamUrl}/${teamId}/chargerLicense`;
export const assignChargerLicenseUrl = (teamId, chargerId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/charger/${chargerId}/charger_license/assign`;
export const sendRenewalNotificationsByLicensesUrl = (teamId) => `${CMS_NEST_ENDPOINT}/team/${teamId}/charger-license/send-renewal-notifications-by-licenses`;
export const paymentUrl = `${CMS_ENDPOINT}/v1/transactions`;
export const initiateChargerLicenseSaleUrl = `${paymentUrl}/license/charger/initiate/sale`;
export const initiateFleetWalletTopupUrl = `${paymentUrl}/rfid/topup/initiate/sale`;
export const getCompanyProductCatalogUrl = (teamId) => `${teamUrl}/${teamId}/productCatalog`;
export const teamPayoutInvoices = (id) => `${teamUrlId(id)}/payout_invoices`;
export const getPayoutInvoicesPdfUrl = (id, payoutId) => `${teamUrlId(id)}/${payoutId}/payout_invoices`
export const teamUsersUrl = `/users`;
export const getTeamUrl = (teamId, url, id) => {
  if (id) return `${CMS_ENDPOINT_V1}/team/${teamId}${url}/${id}`;
  return `${CMS_ENDPOINT_V1}/team/${teamId}${url}`;
};
export const getTeamUrlV2 = (url) => {
  return `${S3_BUCKET_URL}/${url}`;
};
export const getChargerListUrl = (teamId, params) => {
  const searchQuery = params.search ? `&search=${params.search}` : '';
  return `${CMS_ENDPOINT_V1}/team/${teamId}${chargersUrl}?page=${params.page}&pageSize=${params.pageSize}${searchQuery}`;
};
export const getTeamV3Url = (teamId, url, id) => {
  if (id) return `${CMS_NEST_ENDPOINT}/team/${teamId}${url}/${id}`;
  return `${CMS_NEST_ENDPOINT}/team/${teamId}${url}`;
};
export const newGetTeamUrl = (teamId, id) => {
  if (id) return `${CMS_ENDPOINT_V1}/team/${teamId}/charging-profile/${id}`;
  return `${CMS_ENDPOINT_V1}/team/${teamId}/charging-profile`;
};
export const getSettlementPercentageUrl = `${CMS_ENDPOINT_V1}/team/settlementpercentage`;
export const getPaymentDetailsForPriceGroupUrl = (teamId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/paymentDetails`;
export const getPaymentDetailsOfCompany = (companyId) =>
  `${CMS_ENDPOINT_V1}/company/${companyId}/paymentDetails`;
// export const getUserDetailUrl = (id) => `${CMS_ENDPOINT_V1}/user/${id}`;
// export const addUserUrl = `${CMS_ENDPOINT_V1}/user`;
export const getUserDetailUrl = (teamId, id) => `${CMS_ENDPOINT_V1}/team/${teamId}/cmsUser/${id}`;
export const addUserUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/cmsUser`;
export const getUserIdUrl = (userId) => `/user/${userId}`;
export const getUserProfile = () => `${CMS_ENDPOINT_V1}/profile`;
export const getProfileChargerLicenseUrl = (teamId) => `${CMS_ENDPOINT_V1}/profile/${teamId}/chargerLicense`;
// export const companyUrl = `/cms/v1/company`; // OLD V1 VERSION
export const companyUrl = `/cms/v2/company`;
export const getCompanyUrlId = (id) => `${companyUrl}/${id}`;
export const companyFeatureEntitlementsUrl = (id) =>
  `${companyUrl}/${id}/feature-entitlements`;
export const productCatalogUrl = `/cms/v2/product-catalog`;
export const productCategoryUrl = `/cms/v2/product-catalog/category`;
export const companyProductCatalogUrl = `/cms/v2/company/product-catalog`;
export const getCompanyProxyPdf = `${CMS_ENDPOINT}/v2/proxy/pdf`;
export const getCompanyProductCatalogUrlId = (id) =>
  `${companyUrl}/${id}/product-catalog`;
export const getProductCatalogUrlId = (productId) => `${productCatalogUrl}/${productId}`;
export const getProductCategoryUrlId = (categoryId) => `${productCategoryUrl}/${categoryId}`;

// App Filter management (filter categories + filter items used in the mobile app)
// Per-company scoped: /cms/v2/filter/:companyId/...
export const filterBaseUrl = `/cms/v2/filter`;
export const filterCategoryUrl = (companyId) => `${filterBaseUrl}/${companyId}/category`;
export const getFilterCategoryUrlId = (companyId, categoryId) => `${filterCategoryUrl(companyId)}/${categoryId}`;
export const filterItemUrl = (companyId) => `${filterBaseUrl}/${companyId}/item`;
export const getFilterItemUrlId = (companyId, itemId) => `${filterItemUrl(companyId)}/${itemId}`;
export const getFilterItemsByCategoryUrl = (companyId, categoryId) =>
  `${filterItemUrl(companyId)}?categoryId=${categoryId}`;
export const featureUrl = `${CMS_ENDPOINT_V1}/feature`;
export const remoteOperationUrl = `${CMS_ENDPOINT_V1}/remote/operation`;
export const remoteOperationTaskUrl = (chargerId, taskId) =>
  `${CMS_ENDPOINT_V1}/remote/operation/charger/${chargerId}/task/${taskId}`;
export const viewLogsUrl = (id) => `charger/${id}/logs`;
export const getConnectorsUrl = (id) => `${chargerIdUrl(id)}/connectors`;
export const getTagsByChargerIdUrl = (chargerId) =>
  `${chargerIdUrl(chargerId)}/tags`;
export const customerUrl = `${CMS_ENDPOINT_V1}/customer`;
export const customerListByTeamIdUrl = (t) => `${CMS_ENDPOINT_V1}/team/${t}/customer`;
export const mobileCustomersListByTeamIdUrl = (t, page = 0, pageSize = 10, search = "") => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  return `${CMS_ENDPOINT_V1}/team/${t}/mobileCustomers?page=${page}&pageSize=${pageSize}${searchParam}`;
};

export const mobileCpoOnboardingDetailUrl = (companyId, requestPk) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}`;

export const mobileCpoOnboardingTimelineUrl = (companyId, requestPk) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}/timeline`;

export const mobileCpoOnboardingSectionUpdateUrl = (companyId, requestPk, section) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}/sections/${section}`;

export const mobileCpoOnboardingStatusUpdateUrl = (companyId, requestPk) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}/status`;

export const mobileCpoOnboardingHandoffEmailUrl = (companyId, requestPk) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}/handoff-email`;

export const mobileCpoOnboardingHandoffPreviewUrl = (companyId, requestPk) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications/${requestPk}/handoff-preview`;

export const mobileCpoOnboardingStatsUrl = (companyId, start, end, baseStart, baseEnd) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/stats`;

export const mobileCpoChargerInventoryUrl = (companyId, page = 0, pageSize = 10, search = "", status = "") => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  const statusParam = status ? `&status=${encodeURIComponent(status)}` : "";
  return `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/charger_inventory?page=${page}&pageSize=${pageSize}${searchParam}${statusParam}`;
};

export const mobileCpoChargerInventoryUploadUrl = (companyId) =>
  `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/charger_inventory`;

export const mobileCpoOnboardingListUrl = (companyId, page = 0, pageSize = 10, search = "", status = "") => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  const statusParam = status ? `&status=${encodeURIComponent(status)}` : "";
  return `${CMS_ENDPOINT_V1}/mobile-cpo-onboarding/${companyId}/applications?page=${page}&pageSize=${pageSize}${searchParam}${statusParam}`;
};
export const sendPromoCodeMobileCustomerUrl = (t) => `${CMS_ENDPOINT_V1}/team/${t}/mobileCustomers/promocode`;
export const cmCustomerUrl = `${CMS_ENDPOINT_V1}/root/customer`;
export const getCustomerById = (t, id) => `${CMS_ENDPOINT_V1}/team/${t}/customer/${id}`;
export const getCustomerByIdDisable = (t,id) => `${customerUrl}/${id}/team/${t}`;
export const customerTagsById = (teamId, customerId, userTagId) =>
  !userTagId
    ? `${CMS_ENDPOINT_V1}/team/${teamId}/customer/${customerId}/tags`
    : `${CMS_ENDPOINT_V1}/team/${teamId}/customer/${customerId}/tags/${userTagId}`;
export const uploadImgUrl = `${S3_BUCKET_URL}/upload/object`;
export const serviceRequestUrl = (teamId) => `${teamUrl}/${teamId}/support`;
export const serviceRequestForParentUrl = (teamId) =>
  `${serviceRequestUrl(teamId)}`;
export const getServiceRequestDetailsUrl = (teamId, id) => `${serviceRequestUrl(teamId)}/${id}`;
export const chargingProfileListUrl = () =>
  `${CMS_ENDPOINT_V1}/charging-profile`;
// export const chargingProfileDetailsUrl = (chargingProfileId) =>
//   `${chargingProfileListUrl()}/${chargingProfileId}`;
export const paymentGatewayUrl = `/cms/v2/paymentgateway`;
export const availablePaymentGatewayListUrl = `${paymentGatewayUrl}/currency`;
// export const paymentGateway =(paymentGatewayId)=> `${paymentGatewayUrl}/${paymentGatewayId}`
export const logFilterData = (
  chargerId,
  startDate="",
  endDate="",
  timeStart="",
  timeEnd="",
  searchText="",
  direction="",
  status="",
  messageStatus="",
  type="",
  limit="100",
) => {
  return `${S3_BUCKET_URL}/charger/${chargerId}/log/time_interval?startDate=${startDate}&endDate=${endDate}&startTime=${timeStart}&endTime=${timeEnd}&searchText=${searchText}&direction=${direction}&status=${status}&messageStatus=${messageStatus}&type=${type}&limit=${limit}`;
};
export const reportTabData = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/report`;
};
export const reportTabHeaderData = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/report-header`;
};
export const reportExcelDownload = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/report/excel_download`;
};
// Payout Report tab
export const payoutReportList = (teamId, params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Comma-joined (e.g. teamFilter=795,900); backend splits on ",".
      const cleaned = value.filter((v) => v != null && v !== "");
      if (cleaned.length) queryParams.append(key, cleaned.join(","));
    } else if (value != null && value !== "") {
      queryParams.append(key, value);
    }
  });
  const qs = queryParams.toString();
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report${qs ? `?${qs}` : ""}`;
};
export const payoutReportDownload = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report/download`;
};
export const payoutReportEmail = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report/email`;
};

// Create a new export request. POST { periodFrom, periodTo, periodType }.
export const bulkInvoiceExportRequest = (teamId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/invoice-export`;
// List this team's export requests for the Download Center. Expired rows are
// filtered out by the server unless includeExpired=true.
export const bulkInvoiceExportList = (teamId, params = {}) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/invoice-export${buildQuery(params)}`;
// Single request, used to refresh one row after it flips to READY.
export const bulkInvoiceExportById = (teamId, requestId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/invoice-export/${requestId}`;
// Returns the filled statement HTML (template_content) for the email preview —
// the same HTML the email endpoint sends, so the preview matches the email.
export const payoutStatementPreview = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report/statement-preview`;
};
// Returns the Zynka commission-invoice HTML (template_content) for a payout,
// converted to PDF client-side (same flow as the transaction invoice).
export const payoutCommissionInvoice = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report/commission-invoice`;
};
export const getAvailableCharger = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone/availableChargers`;
};
export const getChargeZoneList = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone`;
};
export const deleteChargeZoneById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone/${zoneId}`;
};
export const updateChargeZoneById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone/${zoneId}`;
};
export const getChargeZoneById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone/${zoneId}`;
};
export const createChargeZone = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/chargezone`;
};
export const getchargerPricing = (teamId) => {
  return `${CMS_ENDPOINT_V1}/profile/chargerPricing/${teamId}`;
};
export const addCommentOnTicket = (teamId, ticketId) => {
  return `${serviceRequestUrl(teamId)}/${ticketId}/comment`;
};
export const getAuditLog = (teamId, ticket_id) => {
  return `${serviceRequestUrl(teamId)}/${ticket_id}/audit_log`;
};
export const transactionExcelDownload = ({
  teamId,
  filterteam,
  filterGPTeam,
  companyType,
}) => {
  if (filterGPTeam?.length > 0 || filterteam?.length > 0) {
    if (companyType === "GP") {
      return `${CMS_ENDPOINT_V1}/team/${teamId}/transactions/excel_download?filterCompany=${filterteam.join(
        ","
      )}&filterteam=${filterGPTeam.join(",")}`;
    } else
      return `${CMS_ENDPOINT_V1}/team/${teamId}/transactions/excel_download?filterteam=${filterteam.join(
        ","
      )}`;
  }
  return `${CMS_ENDPOINT_V1}/team/${teamId}/transactions/excel_download`;
};
export const getTransactionUrl = (
  teamId,
  url,
  page,
  pageSize,
  filterteam,
  filterGPTeam,
  companyType,
  search = ""
) => {
  const searchQuery = search ? `&search=${encodeURIComponent(search)}` : "";
  if (filterGPTeam?.length > 0 || filterteam?.length > 0) {
    if (companyType === "GP") {
      return `${CMS_ENDPOINT_V1}/team/${teamId}${url}?page=${page}&pageSize=${pageSize}&filterCompany=${filterteam.join(
        ","
      )}&filterteam=${filterGPTeam.join(",")}${searchQuery}`;
    } else
      return `${CMS_ENDPOINT_V1}/team/${teamId}${url}?page=${page}&pageSize=${pageSize}&filterteam=${filterteam.join(
        ","
      )}${searchQuery}`;
  }
  return `${CMS_ENDPOINT_V1}/team/${teamId}${url}?page=${page}&pageSize=${pageSize}${searchQuery}`;
};
export const getAllExistedTeam = () => {
  return `${CMS_ENDPOINT_V1}/teams`;
};
//master endpoints 
export const getCurrenciesUrl = () => `${CMS_NEST_ENDPOINT}/master/currencies`;
export const getSmsGatewayUrl = () => `${CMS_NEST_ENDPOINT}/master/sms_gateway`;
export const getPaymentGateway = (currencyId) =>
  `${CMS_NEST_ENDPOINT}/master/payment_gateway/${currencyId}`;
export const getDropDownValues = (type) => `${CMS_NEST_ENDPOINT}/master/dropdown/${type}`; 
export const getERPDropDownValues = `${CMS_NEST_ENDPOINT}/master/erp-company`;
//master endpoints 
export const cmsUsersUrl = `${CMS_ENDPOINT_V1}/root/users`;
export const resetPasswordByAdminUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/change/user-password`;
export const cmUserDetailsUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}`;
export const cmUserWalletHistoryUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}/cm-wallet`;
export const cmUserWalletAdjustUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}/cm-wallet/adjust`;
export const cmUserTransactionHistoryUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}/transactions`;
export const cmUserTransactionInvoiceUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}/transactions/invoice`;
export const getPromoCodesUrl = (teamId, userId) => `${CMS_ENDPOINT_V1}/team/${teamId}/mobileCustomers/${userId}/promocodes`;
export const getChargerInstructionBoardUrl = (t, c) => `${getTeamUrl(t, chargerIdUrl(c))}/instruction_board`;
export const getChargerInstructionBoardConnectorUrl = (t, c) => `${getTeamUrl(t, chargerIdUrl(c))}/connector_instruction_board`;
export const getChargerUploadQRUrl = (teamId, chargerId) => `${getTeamUrl(teamId, chargerIdUrl(chargerId))}/upload_qr`;
export const reportGst = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/report/gst`;
};
export const availablePaymentGatewayListByCompanyUrl = (companyId) =>
  `${paymentGatewayUrl}/getPaymentGateway/${companyId}`;
export const thirdPartySmsUrl = '/cms/v2/thirdParty/sms';
export const thirdPartySmsConfig = (companyId) => {return `${thirdPartySmsUrl}/${companyId}`};
export const smsTemplatesUrl = (companyId, templateId) => {
  if (templateId) {
    return `${thirdPartySmsUrl}/templates/${companyId}/${templateId}`;
  }
  return `${thirdPartySmsUrl}/templates/${companyId}`;
};

/* OCPI */
export const OCPI_BASE_URL = `${CMS_ENDPOINT_V2}`;

// Partners endpoints
export const partnersUrl = `${OCPI_BASE_URL}/ocpi/partners`;
export const partnerUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}`;
export const partnerByPartyIdUrl = (partyId) => `${OCPI_BASE_URL}/ocpi/partners/${partyId}/detail`;

// OCPI Tokens endpoints
export const ocpiTokensUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.date_from) queryParams.append('date_from', params.date_from);
  if (params.date_to) queryParams.append('date_to', params.date_to);
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.country_code) queryParams.append('country_code', params.country_code);
  if (params.party_id) queryParams.append('party_id', params.party_id);
  
  return `${OCPI_BASE_URL}/ocpi/emsp/2.2.1/tokens${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

export const ocpiTokenUrl = (countryCode, partyId, uid, type) => 
  `${OCPI_BASE_URL}/ocpi/emsp/2.2.1/tokens/${countryCode}/${partyId}/${uid}/${type}`;

// Partner token management endpoints
export const partnerTokenUrl = `${OCPI_BASE_URL}/ocpi/module/token`;
export const partnerGetTokenUrl = (countryCode, partyId, tokenUid) => 
  `${OCPI_BASE_URL}/ocpi/partners/module/token/${countryCode}/${partyId}/${tokenUid}`;

export const partnerGetAllTokensUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.search) queryParams.append('search', params.search);
  if (params.type) queryParams.append('type', params.type);
  if (params.status) queryParams.append('status', params.status);
  
  return `${OCPI_BASE_URL}/ocpi/module/tokens${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

// OCPI Commands endpoints
export const partnerSendCommandUrl = `${OCPI_BASE_URL}/ocpi/module/commands/send`;
export const partnerCommandStatusUrl = (commandId) => 
  `${OCPI_BASE_URL}/ocpi/partners/module/commands/${commandId}/status`;
export const partnerCommandsUrl = (partnerId, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.date_from) queryParams.append('date_from', params.date_from);
  if (params.date_to) queryParams.append('date_to', params.date_to);
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  
  return `${OCPI_BASE_URL}/ocpi/partners/module/commands/partner/${partnerId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

// Partner onboarding endpoints
export const onboardUrl = `${OCPI_BASE_URL}/ocpi/partners/onboard/wizard`;
export const handshake = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake`;
export const handshakeStatusUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake/status`;
export const handshakeAsyncUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake-async`;
export const handshakeRetryUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake/retry`;
export const handshakeCancelUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake/cancel`;
export const handshakeStatusAsyncUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/partners/${partnerId}/handshake/status-async`;

// Location Module 
export const commandBuilderLocationsUrl = `${OCPI_BASE_URL}/ocpi/module/locations`;

// Command Builder Dropdown APIs
export const commandBuilderDataUrl = `${OCPI_BASE_URL}/ocpi/module/command/data`;
// Active Commands API
export const activeCommandsUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.country_code) queryParams.append('country_code', params.country_code);
  if (params.party_id) queryParams.append('party_id', params.party_id);
  if (params.limit) queryParams.append('limit', params.limit);
  
  return `${OCPI_BASE_URL}/ocpi/module/commands/active${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};
export const commandsHistoryUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.search) queryParams.append('search', params.search);
  if (params.type) queryParams.append('type', params.type);
  if (params.status) queryParams.append('status', params.status);
  if (params.partner_id) queryParams.append('partner_id', params.partner_id);
  return `${OCPI_BASE_URL}/ocpi/module/commands/history${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
}

// Sessions API
export const ongoingSessionsUrl = (params = {}) =>
  `${OCPI_BASE_URL}/ocpi/module/sessions/ongoing${buildQuery(params)}`;

export const completedSessionsUrl = (params = {}) =>
  `${OCPI_BASE_URL}/ocpi/module/sessions/completed${buildQuery(params)}`;

// Tariffs API
export const partnerGetAllTariffsUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.search) queryParams.append('search', params.search);
  if (params.type) queryParams.append('type', params.type);
  if (params.partyId) queryParams.append('partyId', params.partyId);
  
  return `${OCPI_BASE_URL}/ocpi/module/tariffs${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

// EMSP Markup API
export const emspMarkupPartnerUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/module/emsp-markup/partner/${partnerId}`;
export const emspMarkupPartnerDetailsUrl = (partnerId) => `${OCPI_BASE_URL}/ocpi/module/emsp-markup/partner/${partnerId}/details`;
export const emspMarkupUpsertUrl = `${OCPI_BASE_URL}/ocpi/module/emsp-markup/upsert`;

// Payout Run History (NestJS)
export const getPayoutRunHistoryUrl = (companyId, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.status) queryParams.append('status', params.status);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.days) queryParams.append('days', params.days);
  return `${CMS_ENDPOINT_V1}/team/${companyId}/payout_schedule/run-history${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

export const getPayoutRunDetailUrl = (companyId, logId) => 
  `${CMS_ENDPOINT_V1}/team/${companyId}/payout_schedule/run-history/detail/${logId}`;
export const runPayoutScheduleForTeam = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/payout_schedule/run`;
// Analytics API
export const analyticsUrl = `${OCPI_BASE_URL}/ocpi/analytics`;
export const analyticsTypesUrl = `${OCPI_BASE_URL}/ocpi/analytics/types`;
export const analyticsMetadataUrl = `${OCPI_BASE_URL}/ocpi/analytics/metadata`;
export const analyticsMetricsUrl = (category, params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
    queryParams.append(key, value);
    }
  });
  return `${OCPI_BASE_URL}/ocpi/analytics/${category}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};
export const analyticsReportUrl = `${OCPI_BASE_URL}/ocpi/analytics/report`;

// Locations API
export const getAllLocationsUrl = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.search) queryParams.append('search', params.search);
  if (params.status) queryParams.append('status', params.status);
  if (params.partyId) queryParams.append('partyId', params.partyId);
  return `${OCPI_BASE_URL}/ocpi/module/locations${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
};

// OCPI Dashboard API
export const dashboardDataUrl = `${OCPI_BASE_URL}/ocpi/analytics/dashboard-data`;

/* Fleet (FLEET_MANAGEMENT) — team-scoped v1 URLs, combine with getTeamUrl(teamId, url) */
export const fleetOperatorsUrl = (params = {}) => `/fleet/operators${buildQuery(params)}`;
export const fleetOperatorUrl = `/fleet/operator`;
export const fleetOperatorIdUrl = (fleetOperatorId) =>
  `${fleetOperatorUrl}/${fleetOperatorId}`;
export const fleetDriversUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/drivers`;
export const fleetDriverIdUrl = (fleetOperatorId, driverId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/driver/${driverId}`;
export const fleetVehiclesUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/vehicles`;
export const fleetVehicleIdUrl = (fleetOperatorId, vehicleId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/vehicle/${vehicleId}`;
export const fleetAssignmentsUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/assignments`;
export const fleetAssignmentEndUrl = (fleetOperatorId, assignmentId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/assignment/${assignmentId}/end`;
export const fleetChargerAccessUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/charger-access`;
export const fleetChargerAccessIdUrl = (fleetOperatorId, accessId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/charger-access/${accessId}`;
export const fleetTariffsUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/tariffs`;
export const fleetTariffIdUrl = (fleetOperatorId, tariffPlanId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/tariff/${tariffPlanId}`;
export const fleetWalletUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/wallet`;
export const fleetWalletTopupUrl = (fleetOperatorId) =>
  `${fleetWalletUrl(fleetOperatorId)}/topup`;
export const fleetWalletAdjustmentUrl = (fleetOperatorId) =>
  `${fleetWalletUrl(fleetOperatorId)}/adjustment`;
export const fleetWalletLedgerUrl = (fleetOperatorId, params = {}) =>
  `${fleetWalletUrl(fleetOperatorId)}/ledger${buildQuery(params)}`;
export const fleetRfidMappingsUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/rfid-mappings`;
export const fleetRfidMappingIdUrl = (fleetOperatorId, mappingId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/rfid-mapping/${mappingId}`;
export const fleetSessionsUrl = (fleetOperatorId, params = {}) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/sessions${buildQuery(params)}`;
export const fleetReportSummaryUrl = (fleetOperatorId, params = {}) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/reports/summary${buildQuery(params)}`;
export const fleetSessionsReconcileUrl = `/fleet/sessions/reconcile`;
export const fleetOperatorInviteUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/invite`;
export const fleetOperatorUsersUrl = (fleetOperatorId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/users`;
export const fleetOperatorUserIdUrl = (fleetOperatorId, cmsUserId) =>
  `${fleetOperatorIdUrl(fleetOperatorId)}/user/${cmsUserId}`;

//promo codes
export const promoCodesUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/promoCode`;
export const promoCodeByIdUrl = (teamId, promoCodeId) => `${CMS_ENDPOINT_V1}/team/${teamId}/promoCode/${promoCodeId}`;
export const checkPromoCodeUrl = (teamId) => `${CMS_ENDPOINT_V1}/team/${teamId}/promoCode/check`;
export const updatePromoCodeStatusUrl = (teamId, promoCodeId) => `${CMS_ENDPOINT_V1}/team/${teamId}/promoCode/${promoCodeId}/changeStatus`;
export const getLicensesDetailsUrl = (teamId, count = false) => `${CMS_ENDPOINT_V1}/team/${teamId}/dashboard_stats/license${count ? '?count=true' : ''}`;




// onboarding
export const onboardingUrl = () =>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding`;
export const confirmOnboarding = (token)=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/confirm?token=${token}`;
export const paymentOnboardingInitiate = ()=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/payment/initiate`;
export const verifyOnboardingPayment = ()=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/payment/verify`;
export const resendVerificationEmail = ()=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/resend`;
export const getOnboardingUserDetails = (userId)=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/user/${userId}`;
export const pricingPlan = (country)=>`${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms/v1/onboarding/pricing-plans/${country}`;